import jQuery from 'jquery';

export default function () {
    jQuery(function (){
        const buttonLinks = jQuery('.button-link');
        buttonLinks.on('click', function(){
            const buttonElm = jQuery(this);

            if (!buttonElm.prop('disabled')) {
                buttonElm.prop('disabled', true);

                window.location.href = buttonElm.attr('data-href');
            }
        });
        
		window.addEventListener('pageshow', (event) => {
			if (event.persisted) {
				buttonLinks.prop('disabled', false);
			}
		});
    });
}